// actions
export const LOAD_PRACTICES = "LOAD_PRACTICES"
export const DEPLOY_PRACTICE = "DEPLOY_PRACTICE"

// mutations
export const RESET_PRACTICE_LIST = "RESET_PRACTICE_LIST"
export const SET_PRACTICE_LIST = "SET_PRACTICE_LIST"
export const SET_NEW_PRACTICE_STATE = "SET_NEW_PRACTICE_STATE"
